var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "tenera-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "currentColor",
    d: "M9,14l-1,1v8H1V9.5l11-8.2c3.7,2.7,7.3,5.5,11,8.2v3.6c0.4,0.4,0.7,0.8,1,1.3V9c-4-3-8-6-12-9L0,9v15h9v-9h2.7 c0.2-0.4,0.4-0.7,0.6-1H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "currentColor",
    d: "M18,12c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6S21.314,12,18,12z M20.667,18.667h-2v2 c0,0.368-0.299,0.666-0.666,0.666s-0.667-0.299-0.667-0.666v-2h-2c-0.368,0-0.666-0.299-0.666-0.667s0.299-0.666,0.666-0.666h2v-2 c0-0.368,0.299-0.666,0.667-0.666c0.369,0,0.666,0.299,0.666,0.666v2h2c0.369,0,0.666,0.299,0.666,0.666 S21.035,18.667,20.667,18.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProperty);
export default __webpack_public_path__ + "static/media/add-property.ce7bdba6dd5b8f0e7fa997a44ac36f3d.svg";
export { ForwardRef as ReactComponent };